 import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { WelcomePage } from "../welcome/welcome";
/**
 * Generated class for the SignupSuccessPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-signup-success',
  templateUrl: 'signup-success.html',
})
export class SignupSuccessPage {
  email: any;
  constructor(public navCtrl: NavController, public navParams: NavParams) {
    this.email = this.navParams.get('email');
  }

  gotoWelcome() {
    this.navCtrl.setRoot(WelcomePage);
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad SignupSuccessPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/signup-success/signup-success.ts